module.exports = __webpack_public_path__ + "img/advil_allergy_sinus_relief_coated_caplets.8eb47b25.png";